<template>
  <div
    class="bg-white mb-[24px]"
  >
    <div class="flex items-center justify-between gap-[8px] mb-[24px] px-[20px] py-[16px] border-b-[1px] border-b-[#E5E5E5]">
      <div class="flex items-center gap-[8px] shrink-1">
        <Button
          outline
          type="icon"
          @click="handleBack"
        >
          <span class="k-arrow-left-2 text-[#0A0A0A]" />
        </Button>
        <span class="text-[#0A0A0A] font-semibold">
          Detail Pengajuan Packing
        </span>
      </div>
      <CancelOrderButton
        ref="cancelBtn"
        :status="data.status"
        @cancel="cancelPacking"
      />
    </div>

    <div class="border rounded-[12px] mx-[24px] p-[16px] mb-[24px]">
      <div class="grid sm:grid-cols-2 lg:grid-cols-4 gap-[24px] text-[14px] text-[#0A0A0A]">
        <div class="flex items-start justify-start flex-col gap-[4px]">
          <div class="font-medium mb-[4px]">
            Tanggal Order
          </div>
          <div>
            {{ orderDate }}
          </div>
          <div class="capitalize text-[#737373] text-[12px]">
            {{ orderTime }}
          </div>
        </div>
        <div class="flex items-start justify-start flex-col gap-[4px]">
          <div class="font-medium mb-[4px]">
            Gudang
          </div>
          <div>
            {{ warehouse.name }}
          </div>
          <div class="capitalize text-[#737373] text-[12px]">
            {{ warehouse.location }}
          </div>
        </div>
        <div class="flex items-start justify-start flex-col gap-[4px]">
          <div class="font-medium mb-[4px]">
            Label Pengiriman
          </div>
          <div
            v-if="!loading"
            class="flex justify-between items-center gap-[5px] w-full"
          >
            <div class="flex items-center gap-[5px]">
              <b-img
                v-if="!label_name"
                src="https://storage.googleapis.com/komerce/icon/error_file.svg"
                width="24"
                height="24"
                alt="label"
              />
              <a
                v-b-tooltip.hover.top="label_name || 'File Error'"
                class="truncate text-[#0A0A0A] hover:text-[#0A0A0A] hover:underline max-w-[150px] md:max-w-[180px]"
                :href="label_url"
                target="_blank"
              >
                {{ label_name || 'File Error' }}
              </a>
              <b-form-file
                ref="label_ref"
                v-model="label_file"
                accept="application/pdf"
                class="mt-3"
                plain
                hidden="true"
              />
            </div>
            <b-button
              v-if="!label_name"
              variant="primary"
              size="sm"
              @click="$refs.label_ref.$el.click()"
            ><i class="k-export-2 mr-[10px]" /><span>Reupload</span></b-button>
            <b-button
              v-if="label_file"
              variant="primary"
              size="sm"
              class="d-flex items-center"
              @click="uploadLabel"
            ><b-spinner
              v-if="reupload_inprogress"
              small
            /><span class="ml-[5px]">{{ reupload_inprogress ? "Menyimpan..." : "Simpan" }}</span></b-button>
          </div>
          <div
            v-else
            class="text-[#626262]"
          >
            -
          </div>
        </div>
        <div class="flex items-start justify-start flex-col gap-[4px]">
          <div class="font-medium mb-[4px]">
            Outbond ID
          </div>
          <div>
            {{ data.id || '-' }}
          </div>
          <div
            v-b-tooltip.hover.top="labelFirstDownloadTooltip"
            class="text-[#737373] text-[12px]"
          >
            {{ labelDownloadAtText }}
          </div>
        </div>
      </div>
    </div>

    <div class="px-[24px] pb-[24px] mb-[24px] border-b-[1px] border-[#E5E5E5]">
      <Table
        ref="orderTable"
        :items="data.order_summary"
        :grand-total-order="grandTotalOrder"
        :batch-status="data.status"
        @update-selected="onSelectedChange"
      />
    </div>

    <div class="flex items-end justify-end gap-[6px] text-[#0A0A0A] text-[14px] font-medium pb-[100px] mx-[24px]">
      <div class="grow text-right">
        <p>Total Order</p>
        <p>Total Biaya Fulfillment</p>
      </div>
      <div>
        <p>: {{ grandTotalOrder }}</p>
        <p>: {{ grand_fulfillment_fee | rupiah }}</p>
      </div>
    </div>

    <ModalConfirm
      ref="modalConfirm"
    />
    <ModalConfirmCancelOrder ref="modalConfirmCancelOrder" />
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'
import { newAxiosIns } from '@/libs/axios'
import { toast_error, toast_success } from '@/libs/toastification'
import filters from '@/libs/filters'
import { Button } from '@/@core/components/ui'
import moment from 'moment'
import { TIME_DOT, DAY_FULL_DATE_TIME } from '@/libs/formatDate'
import Table from './components/Table.vue'
import ModalConfirm from './components/ModalConfirm.vue'
import CancelOrderButton from './components/CancelOrderButton.vue'
import ModalConfirmCancelOrder from './components/ModalConfirmCancelOrder.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    Table,
    ModalConfirm,
    CancelOrderButton,
    Button,
    ModalConfirmCancelOrder,
  },
  filters: { rupiah: filters.rupiah },
  props: {
    detailId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: {},
      refId: this.$route.query.ref_id,
      label_file: null,
      loading: false,
      items: [],
      status: '',
      label_url: '',
      label_name: '',
      grand_total_order: 0,
      grand_fulfillment_fee: 0,
      warehouse: {
        name: '-',
        location: '-',
      },
      reupload_inprogress: false,
    }
  },
  computed: {
    grandTotalOrder() {
      return this.data.order_summary?.reduce((acc, item) => (item.status !== 'Dibatalkan' ? acc + item.total_order : acc), 0) || 0
    },
    totalOrderUnprocessed() {
      return this.data.order_summary?.reduce((acc, item) => (item.status !== 'Dibatalkan' ? acc + 1 : acc), 0) || 0
    },
    outboundId() {
      return this.data.id ? this.data.id : (this.refId || this.detailId)
    },
    orderDate() {
      const date = new Date(this.data.created_at)
      return date.toLocaleDateString('id-ID', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    },
    orderTime() {
      const date = new Date(this.data.created_at)
      return date.toLocaleTimeString('id-ID', {
        hour: '2-digit',
        minute: '2-digit',
      })
    },
    /**
     * Formats the label download timestamp relative to current date.
     * @returns {string}
     */
    labelDownloadAtText() {
      const timestamp = this.data.last_printed_at
      if (!timestamp) return 'Label belum diunduh'
      const formattedDate = (moment(timestamp).isSame(moment(), 'day'))
        ? TIME_DOT(timestamp)
        : DAY_FULL_DATE_TIME(timestamp)
      return `Label diunduh pada ${formattedDate}`
    },
    labelFirstDownloadTooltip() {
      const timestamp = this.data.printed_at
      if (!timestamp) return ''
      return `Label pertama diunduh pada ${DAY_FULL_DATE_TIME(timestamp)}`
    },
  },
  watch: {
    label_file(new_value) {
      if (new_value.name) this.label_name = new_value.name
      this.label_url = URL.createObjectURL(new_value)
    },
  },
  created() {
    this.selectedItems = []
  },
  mounted() {
    this.fetchDetailPacking()
  },
  beforeDestroy() {
    this.data = {}
  },
  methods: {
    handleBack() {
      if (this.$listeners && this.$listeners.back) {
        this.$emit('back')
      } else {
        this.$router.back()
      }
    },
    onSelectedChange(selected) {
      this.selectedItems = selected
      if (this.$refs.cancelBtn) {
        this.$refs.cancelBtn.setCancelable(selected.length > 0)
      }
    },
    /**
     * Reuploads the label file to the server and handles the upload process.
     */
    uploadLabel() {
      this.reupload_inprogress = true
      const formData = new FormData()
      formData.append('label', this.label_file)

      newAxiosIns
        .put(`/kompack/api/v1/outbounds/label/${this.outboundId}`, formData)
        .then(() => {
          toast_success({
            title: 'Berhasil!',
            message: 'Label pengiriman berhasil diunggah.',
          })
          this.label_file = null
          this.fetchDetailPacking()
          this.selectedItems = []
        })
        .catch(() => {
          toast_error({
            title: 'Gagal!',
            message: 'Terjadi kesalahan, file kamu gagal diunggah. Coba lagi nanti.',
          })
          this.label_name = null
          this.label_file = null
        })
        .finally(() => {
          this.reupload_inprogress = false
        })
    },
    async fetchDetailPacking() {
      this.loading = true
      await newAxiosIns
        .get(
          `/kompack/api/v1/outbounds/${this.refId}`,
        )
        .then(res => {
          const { data } = res.data

          this.data = data

          this.label_url = data.label_url
          this.label_name = data.label_name
          this.grand_fulfillment_fee = data.grand_fulfillment_fee
          this.warehouse.name = data.warehouse_name
          this.warehouse.location = data.warehouse_location.toLowerCase()

          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$toast_error({ message: 'Terjadi kesalahan, silakan coba lagi.' })
        })
    },
    cancelPacking() {
      const cancelOrderItems = this.selectedItems.map(item => this.data.order_summary[item])
      this.$refs.modalConfirmCancelOrder.show({
        awbBeenDownloaded: !!this.data.printed_at,
        data: cancelOrderItems,
        onSaveFn: async () => {
          await this.processPackingCancelation()
        },
      })
    },
    packingCancelationSuccess() {
      const description = this.data.status === 'Belum Dipacking'
        ? 'Order berhasil dibatalkan. Biaya Fulfillment akan direfund 100% ke Saldo Kompay kamu.'
        : 'Order berhasil dibatalkan. Biaya Penyimpanan dan Biaya Teknologi akan direfund ke Saldo Kompay kamu.'

      this.$refs.modalConfirm.show({
        title: 'Berhasil Dibatalkan',
        description,
        type: 'success',
      })

      this.fetchDetailPacking()
    },
    /**
     * Processes the packing cancelation for the selected items.
     */
    async processPackingCancelation() {
      if (!this.selectedItems.length) return

      this.$refs.cancelBtn.setLoading(true)

      const payload = {
        cancel_all: this.selectedItems.length === this.totalOrderUnprocessed,
        outbound_detail_ids: this.selectedItems.map(item => this.data.order_summary[item].outbound_detail_id),
      }

      try {
        await this.$http_new.put(`/kompack/api/v1/outbounds/${this.outboundId}/cancel`, payload)

        this.packingCancelationSuccess()
      } catch (error) {
        this.$toast_error({ message: 'Pembatalan pengajuan gagal. Silakan coba lagi.' })
      } finally {
        this.loading = false
        this.$refs.cancelBtn.setLoading(false)
      }
    },
    goBack() {
      if (window.history.length <= 1) {
        this.$router.push({ name: 'history-pickup', query: { type: 'non-komship' } })
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>
